import { selectors } from './reducer';

export const getUsers = selectors.getData;
